export enum CampaignStatus {
  ongoing,
  neverStarted,
  ended,
  unknown // This is a catch-all for any other status; just in case
}